import {
  NumberCircleOne,
  Sparkle,
  NumberCircleTwo,
  PencilSimpleLine,
  NumberCircleThree,
  PaperPlaneTilt,
  NumberCircleFour,
  Receipt,
  NumberCircleFive,
  Repeat,
} from '@phosphor-icons/react'

export function SidebarIndex() {
  return (
    <div className="twc-prose twc-prose-sm dark:twc-prose-invert twc-max-w-none twc-bg-amber-100 dark:twc-bg-slate-900 twc-rounded twc-shadow-xl twc-p-4 dark:twc-border dark:twc-border-slate-800">
      <h2 className="twc-font-semibold">How to rent props, step-by-step</h2>

      <div className="twc-not-prose twc-max-w-xl twc-mx-auto">
        <ol className="twc-flex twc-flex-col twc-gap-4 twc-justify-center">
          <li className="twc-flex twc-gap-2 twc-items-center twc-leading-normal twc-rounded twc-py-4 twc-px-2 sm:twc-pl-4 sm:twc-pr-6 twc-bg-amber-200 dark:twc-bg-slate-800">
            <NumberCircleOne
              className="sm:twc-mr-4 twc-basis-20"
              size={48}
              weight="duotone"
              aria-label="Step 1"
            />

            <p className="twc-mx-auto">
              <strong className="twc-text-lg">Start Request</strong>
              <Sparkle size={18} className="twc-align-baseline twc-inline twc-ml-1" />
              <br />
              <span className="twc-text-sm">
                Select/create your project, add props, and then Start New Request
              </span>
            </p>
          </li>
          <li className="twc-flex twc-gap-2 twc-items-center twc-leading-normal twc-rounded twc-py-4 twc-px-2 sm:twc-pl-4 sm:twc-pr-6 twc-bg-amber-200 dark:twc-bg-slate-800">
            <NumberCircleTwo
              className="sm:twc-mr-4 twc-basis-20"
              size={48}
              weight="duotone"
              aria-label="Step 2"
            />
            <p>
              <strong className="twc-text-lg">Add Info</strong>
              <PencilSimpleLine className="twc-align-baseline twc-inline twc-ml-1" size={18} />
              <br />
              <span className="twc-text-sm">
                Add Contact, Project, Rental Dates, and Pick-up/Delivery info
              </span>
            </p>
          </li>
          <li className="twc-flex twc-gap-2 twc-items-center twc-leading-normal twc-rounded twc-py-4 twc-px-2 sm:twc-pl-4 sm:twc-pr-6 twc-bg-amber-200 dark:twc-bg-slate-800">
            <NumberCircleThree className="sm:twc-mr-4 twc-basis-20" size={48} weight="duotone" />
            <p>
              <strong className="twc-text-lg">Submit!</strong>
              <PaperPlaneTilt className="twc-align-baseline twc-inline twc-ml-1" size={18} />
              <br />
              <span className="twc-text-sm">
                Review &amp; Submit the form to share your cart and info with ACME
              </span>
            </p>
          </li>
          <li className="twc-flex twc-gap-2 twc-items-center twc-leading-normal twc-rounded twc-py-4 twc-px-2 sm:twc-pl-4 sm:twc-pr-6 twc-bg-amber-200 dark:twc-bg-slate-800">
            <NumberCircleFour className="sm:twc-mr-4 twc-basis-20" size={48} weight="duotone" />

            <p>
              <strong className="twc-text-lg">Get A Quote</strong>{' '}
              <Receipt className="twc-align-baseline twc-inline twc-ml-1" size={18} />
              <br />
              <span className="twc-text-sm">
                We&apos;ll reply back, send you a quote, and place on hold what&apos;s available
              </span>
            </p>
          </li>
          <li className="twc-flex twc-gap-2 twc-items-center twc-leading-normal twc-rounded twc-py-4 twc-px-2 sm:twc-pl-4 sm:twc-pr-6 twc-bg-amber-200 dark:twc-bg-slate-800">
            <NumberCircleFive className="sm:twc-mr-4 twc-basis-20" size={48} weight="duotone" />

            <p>
              <strong className="twc-text-lg">Update &amp; Repeat!</strong>{' '}
              <Repeat className="twc-align-baseline twc-inline twc-ml-1" size={18} />
              <br />
              <span className="twc-text-sm">
                Re-submit when you make changes to your cart, and/or edit info
              </span>
            </p>
          </li>
        </ol>
      </div>
    </div>
  )
}
